const USER_TYPES = {
  admin: 'Admin',
  end_user: 'End User',
  user: 'User',
  super_admin: 'Super Admin',
};

export default USER_TYPES;
